import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "utils/@reduxjs/toolkit";
import { useInjectReducer } from "utils/redux-injectors";
import { ResetPasswordState } from "./types";
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery, endpoints, formatErrors } from "utils/api/endpoints";

export const initialState: ResetPasswordState = {
  isLoading: false,
  error: null,
  data: null,
};

// RTK Query API for reset password
export const api = createApi({
  reducerPath: "resetPasswordApi",
  baseQuery,
  endpoints: (builder) => ({
    resetPassword: builder.mutation<any, { password: string; token: string }>({
      query: (body) => ({
        url: endpoints.resetPassword.url,
        method: endpoints.resetPassword.method,
        body: body,
      }),
      transformResponse: (response: any) => response || [],
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
  })
});

const slice = createSlice({
  name: "resetPassword",
  initialState,
  reducers: {
    someAction(state, action: PayloadAction<any>) {},
  },
});

export const { actions: resetPasswordActions, reducer: resetPasswordReducer } = slice;

export const useResetPasswordSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });

  return {
    actions: slice.actions,
    ...api,
  };  
};

export const { useResetPasswordMutation } = api; 